import 'SafeApply/angularModule';

export default angular.module('DragAndDrop', ['AClassAbove', 'safeApply']);
